import { routes as Home } from '@/views/home/index.js'
import { routes as Paychecks } from '@/views/paychecks/index.js'
import { routes as Scales } from '@/views/scales/index.js'
import { routes as IncomeTax } from '@/views/IncomeTax/index.js'
export default [
  {
    path: '/',
    name: 'dashboard',
    redirect: '/home',
    component: () => import('./Dashboard.vue'),
    meta: {
      name: 'Dashboard',
    },
    children: [...Home, ...Paychecks, ...Scales, ...IncomeTax],
  },
]
